import React, { useEffect, useState } from 'react';
export function StickyNav() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(!entry.isIntersecting);
    }, {
      threshold: 0.1
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  if (!isVisible) return null;
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-primary/95 backdrop-blur-md border-b border-white/10 py-3.5 animate-in slide-in-from-top-full duration-300" data-id="element-55">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-56">
        <div className="flex flex-wrap justify-between items-center gap-4 md:justify-between justify-center" data-id="element-57">
          <span className="font-playfair text-base font-black text-accent" data-id="element-58">
            Reflujo Cero en 72h
          </span>
          <span className="text-text-muted text-sm hidden md:inline-flex items-center gap-2" data-id="element-59">
            <span className="price-struck text-sm font-semibold" data-id="element-60">120 USD</span>
            <strong className="text-accent text-lg font-black" data-id="element-61">
              Hoy 12 USD
            </strong>
          </span>
          <a href="https://pay.hotmart.com/S104868471X" target="_blank" rel="noopener noreferrer" className="btn-sweep bg-gradient-to-r from-accent via-accent-light to-accent-dark text-primary text-sm font-extrabold py-2.5 px-6 rounded-md no-underline whitespace-nowrap transition-transform hover:scale-105" data-id="element-62">
            Quiero acceso ahora
          </a>
        </div>
      </div>
    </nav>;
}